import {
   MdChevronRight,
   MdChevronLeft,
   MdKeyboardDoubleArrowRight,
   MdKeyboardDoubleArrowLeft,
   MdUndo,
   MdRedo,
} from "react-icons/md";

// ─── Transfer Buttons ─────────────────────────────────────────────────────────
export function TransferButtons({
   onAddAll,
   onAdd,
   onRemove,
   onRemoveAll,
   onUndo,
   onRedo,
   canUndo,
   canRedo,
}) {
   const btn =
      "flex items-center justify-center w-9 h-9 rounded-lg border! border-(--borderColor)! bg-(--inputBackgroundColor) text-(--textColor) hover:text-(--primaryColor) hover:border-(--primaryColor)! active:scale-95 transition-all duration-100 shadow-sm disabled:opacity-40 disabled:cursor-not-allowed";
   const btnSm =
      "flex items-center justify-center w-9 h-9 rounded-lg border! border-(--borderColor)! bg-(--inputBackgroundColor) text-(--textColor) hover:text-(--primaryColor) hover:border-(--primaryColor)! active:scale-95 transition-all duration-100 shadow-sm disabled:opacity-40 disabled:cursor-not-allowed";
   return (
      <div className="flex flex-col items-center justify-center gap-2 px-2!">
         <button type="button" title="Mover todos para direita (→)" onClick={onAddAll} className={btn}>
            <MdKeyboardDoubleArrowRight size={18} />
         </button>
         <button type="button" title="Mover selecionados para direita" onClick={onAdd} className={btn}>
            <MdChevronRight size={18} />
         </button>
         <button type="button" title="Mover selecionados para esquerda" onClick={onRemove} className={btn}>
            <MdChevronLeft size={18} />
         </button>
         <button type="button" title="Mover todos para esquerda (←)" onClick={onRemoveAll} className={btn}>
            <MdKeyboardDoubleArrowLeft size={18} />
         </button>

         {/* Divider */}
         <div className="w-5 border-t! border-(--borderColor)! my-0.5!" />

         <button
            type="button"
            title="Desfazer (Ctrl+Z)"
            onClick={onUndo}
            disabled={!canUndo}
            className={btnSm}
         >
            <MdUndo size={18} />
         </button>
         <button
            type="button"
            title="Refazer (Ctrl+Shift+Z)"
            onClick={onRedo}
            disabled={!canRedo}
            className={btnSm}
         >
            <MdRedo size={18} />
         </button>
      </div>
   );
}